module.exports = __webpack_public_path__ + "static/media/elm-logo.1610d456.png";